import * as actions from './index';

export const reportMissingSchool = (dao, params) => {
  const promise = dao.reportMissingSchool(params);

  return (dispatch) => {
    dispatch({ type: actions.REPORT_SCHOOL });

    return promise
      .then(() => dispatch({ type: actions.REPORT_SCHOOL_SUCCESS }))
      .catch(() => dispatch({ type: actions.REPORT_SCHOOL_ERROR }));
  };
};

export const updateEditingEvent = (event) => {
  return { type: actions.UPDATE_EDITING_EVENT, event, };
};

export const resetAllState = () => {
  return { type: actions.RESET_ALL_STATE };
};

export const updateEditingTask = (task) => {
  return { type: actions.UPDATE_EDITING_TASK, task };
};

export const updateEditingList = (list) => {
  return { type: actions.UPDATE_EDITING_LIST, list };
};

export const updateEditingTourney = (tourney) => {
  return { type: actions.UPDATE_EDITING_TOURNEY, tourney };
};

export const resetRecruitsState = () => {
  return { type: actions.RESET_RECRUITS_STATE };
};

export const getTop20Recruits = (dao, list) => {
  const promise = dao.recruits.get({ listId: list.id });

  const onSuccess = (dispatch, top20Recruits) => dispatch({
    type: actions.GET_TOP20_RECRUITS_SUCCESS,
    top20Recruits,
  });

  const onError = (dispatch, error) => dispatch({
    type: actions.GET_TOP20_RECRUITS_ERROR,
    error,
  });

  return (dispatch) => {
    if (!list.id) {
      return onSuccess(dispatch, []);
    }
    dispatch({ type: actions.GET_TOP20_RECRUITS, promise });
    return promise
      .then(({ results }) => onSuccess(dispatch, results))
      .catch((error) => onError(dispatch, error));
  };
};

export const getSingleListRecruits = (dao, params) => {
  const promise = dao.recruits.get(params);

  const onSuccess = (dispatch, listRecruits) => dispatch({
    type: actions.GET_LIST_RECRUITS_SUCCESS,
    listRecruits,
  });

  const onError = (dispatch, error) => dispatch({
    type: actions.GET_LIST_RECRUITS_ERROR,
    error,
  });

  return (dispatch) => {
    dispatch({ type: actions.GET_LIST_RECRUITS, promise });
    return promise
      .then(({ results }) => onSuccess(dispatch, results))
      .catch((error) => onError(dispatch, error));
  };
};

export const getProcessedGameData = (dao, params) => {
  const promise = dao.processedGameData.getAll(params);

  const onSuccess = (dispatch, data) => dispatch({
    type: actions.GET_PROCESSED_DATA_SUCCESS,
    data,
  });

  const onError = (dispatch, error) => dispatch({
    type: actions.GET_PROCESSED_DATA_ERROR,
    error,
  });

  return (dispatch) => {
    dispatch({ type: actions.GET_PROCESSED_DATA, promise });
    return promise
      .then((results) => onSuccess(dispatch, results))
      .catch((error) => onError(dispatch, error));
  };
};

export const deleteScrapeJob = (dao, id) => {
  const promise = dao.scrapeJobs.deleteJob(id);

  const onSuccess = (dispatch, id) => dispatch({
    type: actions.DELETE_SCRAPE_JOB_SUCCESS,
    id,
  });

  const onError = (dispatch, error) => dispatch({
    type: actions.DELETE_SCRAPE_JOB_ERROR,
    error,
  });

  return (dispatch) => {
    dispatch({ type: actions.DELETE_SCRAPE_JOB, promise });
    return promise
      .then((results) => onSuccess(dispatch, id))
      .catch((error) => onError(dispatch, error));
  };
};

export const getAccountInfo = (dao, id) => {
  const promise = dao.staff.getAccountInfo(id);

  const onSuccess = (dispatch, data) => dispatch({
    type: actions.GET_ACCOUNT_INFO_SUCCESS,
    data,
  });

  const onError = (dispatch, error) => dispatch({
    type: actions.GET_ACCOUNT_INFO_ERROR,
    error,
  });

  return (dispatch) => {
    dispatch({ type: actions.GET_ACCOUNT_INFO, promise });
    return promise
      .then((results) => onSuccess(dispatch, results))
      .catch((error) => onError(dispatch, error));
  };
};


// WEBPACK FOOTER //
// ./src/js/FastRecruit/actions/miscActions.jsx